export * from "./JackpotDataProvider";
//# sourceMappingURL=index.js.map